// extracted by mini-css-extract-plugin
export default {"container":"AlertsIndex_container__Zvaxr"};